import { Box, Checkbox, FormControlLabel,  Typography } from "@mui/material";
import { ChecklistItemType } from "../../types/checklistItem";
import React, { Suspense, useState } from "react";
const Modal = React.lazy(() => import('@mui/material/Modal'));
export default function ChecklistItem({
  item,
  onChange
}: {
  item: ChecklistItemType;
  onChange: (item: ChecklistItemType) => void;
}): JSX.Element {

  const [showModal, setShowModal] = useState(false);

  return (
    <>
    <Box display="flex" gap="1rem" >
      <FormControlLabel
      onClick={() => {
       setShowModal(true)
      }}

        sx={{ '& .MuiFormControlLabel-label': { fontSize: '30px' } }}
        label={item.label}
        control={
          <Checkbox
            sx={{ '& .MuiSvgIcon-root': { fontSize: 50 } }}
            checked={item.isChecked}
            onChange={() => onChange({ ...item, isChecked: !item.isChecked })}
          />
        }
      />
    </Box>
    {showModal&&
    <Suspense fallback={<div>Loading...</div>}>
    <Modal
    open={showModal}
    onClose={
      () => {
        setShowModal(false)
      }
    }
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
  >
    <Box >
      <Typography id="modal-modal-title" variant="h6" component="h2">
        Text in a modal
      </Typography>
      <Typography id="modal-modal-description" sx={{ mt: 2 }}>
        Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
      </Typography>
    </Box>
  </Modal></Suspense>}</>
  );
}